module.exports = __webpack_public_path__ + "static/media/ic_tv_-1.ac21079d.svg";